// extracted by mini-css-extract-plugin
export default {"content":"HeaderFooterPage_content__0fYHg","loading":"HeaderFooterPage_loading__fU6HW","form":"HeaderFooterPage_form__esKoT","formActions":"HeaderFooterPage_formActions__nTeEu"};